import React, { useState, useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import { Input } from 'reactstrap';
import Footer from '../../components/footer/Footer';
import Logo from '../../components/assets/amil-pride.svg';
import Header from '../../components/header/Header';
import { AgeStyle } from './formsStyle';
import cornerRightArrow from '../../components/assets/corner-right-down.svg';
import imageSource from '../../components/assets/idades-beneficiarios.webp';
import ProgressBar from '../../components/status/ProgressBar';

const FormAge = () => {
  const [progress, setProgress] = useState(3);

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  const [age, setAge] = useState('');

  // Estado para controlar a visibilidade do texto adicional
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  // Função para alternar a visibilidade
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (isNaN(value) || value < 0) {
      value = ''; // Clears the field if the value is not a positive number
    } else {
      value = Math.min(value, 99);
      value = value.toString();
    }
    setAge(value);
  };

  useEffect(() => {
    const dataToSave = { age };
    sessionStorage.setItem('@individualData', JSON.stringify(dataToSave));
  }, [age]);

  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem('@individualData'));
    if (savedData && savedData.age) {
      setAge(savedData.age);
    }
  }, []);

  return (
    <>
      <AgeStyle>
        <section className="formAge">
          <div className="logo-wrapper">
            <img className="logo-img" src={Logo} alt="Logo Pride" />
          </div>
          <div className="formAge_title__container">
            <h1 className="formAge_title">Qual é sua idade?</h1>

            <div className="question__wrapper">
              <p className="text" onClick={toggleDropdown}>
                Por que essa pergunta?{' '}
                <img
                  className={`arrow ${isDropdownOpen ? 'up' : ''}`}
                  src={cornerRightArrow}
                  alt="Saiba mais"
                />
              </p>
              {/* Texto adicional que é mostrado/ocultado baseado no estado */}
              <p className={`dropdown-content ${isDropdownOpen ? 'open' : ''}`}>
                Para ajustar planos e preços conforme faixa etária e
                necessidades de saúde.
              </p>
            </div>
          </div>
          <div className="formAge_fields__container">
            <div className="formAge_field__container">
              <Input
                type="number"
                name="age"
                placeholder="Insira sua idade"
                value={age || ''}
                onChange={handleChange}
                min="0"
              />
            </div>
          </div>
          <ProgressBar progress={progress} steps={5} />
        </section>
        <Footer />
      </AgeStyle>
    </>
  );
};

export default FormAge;
